import React,{useEffect} from 'react'

import actual_JSON from '/static/data/content.json'

import Fuse from 'fuse.js'

import * as utils from './Helpers/SearchHelper'

import '../../styles/preisrechner.css'

import search from '../../assets/preisrechner/svg/search.svg'
import close from '../../assets/preisrechner/svg/close.svg'


const fuseOptions = {
			keys: [
		    	"name",
		    	"synonyms"
		  	],
		  	includeScore: true,
        useExtendedSearch: true
		};

const SearchTab = props => {

	var fuse;

	useEffect(() => {
		utils.setActualJson(actual_JSON);
	    let services = actual_JSON.Services.map(x => [x.synonyms,x.name]).flat(2).sort();
		services.forEach((x,i) =>
			document.getElementsByClassName("services")[0].appendChild(utils.createLI(x,props.setService,i))
		);
		fuse = new Fuse(actual_JSON.Services, fuseOptions);
    if (props.storage() >=0){
      utils.setSearchField(actual_JSON.Services[props.storage()].name,(x)=>{},props.storage());
    }
    document.getElementById('search').focus();
	});


  	return (
    <div className="step">
      <div className="vermTitle preisrechner">
          <h1>Preisrechner</h1>
          <p>in 3 Klicks zu deiner Offerte</p>
        </div>
      <div className="vermFormContent">
        <div className="vermLeftContent"></div>
        <div className="vermCenterContent">
          <div className="vermSearch">
            <input autoFocus placeholder="Suche deine Vermessungs-Dienstleistung" onInput={() => utils.search(fuse,props.setService)} onFocus={utils.hideServices} type="text" id="search" />
            <img className="search" src={search}/>        

            <button className="close-search" aria-label="close-search" onClick={utils.deleteInput}>
            <img src={close}/> 
            </button>
          </div>
          <div className="search-results">
            <div className="search-result"> </div>
            <div className="search-noresult">
              <p>Nichts gefunden? Sieh dir alle unsere <button onClick={utils.showServices}>Dienstleistungen</button> an.</p>
            </div>
          </div>

          <div className="service">
            <button className="service-btn" onClick={utils.showServices}>
              <p className="service-text">Alle Dienstleistungen</p>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.62 9.72" className="open">
                <defs>
                  <style>
                  </style>
                </defs>
                <g id="Ebene_2" data-name="Ebene 2">
                  <g id="Text">
                    <polyline className="cls-1" points="15.91 0.71 8.31 8.31 0.71 0.71"></polyline>
                  </g>
                </g>
              </svg>
            </button>

          </div>
          <div className="services">
          </div>
        </div>


        <div className="vermRightSide">
          <div className="vermRightContent">
            <div className="vermHeading headRight">
              Höhenaufnahme
            </div>
          </div>
        </div>

      </div>
    </div>
	)
}

export default SearchTab